import { Injectable } from '@angular/core';
import { sp } from "@pnp/sp";
import { ListTitles } from "../services/constants";
import { IItemUpdateResult, IItemAddResult } from '@pnp/sp/items';
import { brandTrackerData } from '../services/models';
import { execute } from '../services/utils';

@Injectable({
  providedIn: 'root'
})
export class BrandTrackerService {
  brandName: string = "";
  brandId: any;

  async getAllBrandNames(): Promise<any> {
    const getAllBrands = await sp.web.lists.getByTitle(ListTitles.brandTrackerNames).items
      .select('Title,Id,Brand_x0020_Description,BrandLogoUrl,BrandPrimaryColor,BrandSecondaryColor')
      .filter(`Title eq '${this.brandName}'`)
      .get();
      console.log(getAllBrands);
    return getAllBrands;
  }

  async getTAs(): Promise<any> {
  //  if (this.brandId && this.brandId.length > 0) {
      const getAllTAs = await sp.web.lists.getByTitle(ListTitles.brandTrackerTAs).items
        .select('Title,Id,Brand/Title,Brand/Id,TAIconUrl,TADescription')
        .expand('Brand')
        .filter(`Brand/Title eq '${this.brandName}'`)
        .getAll();
        console.log(getAllTAs);
      return getAllTAs;
   // }
  }

  async getIndications(): Promise<any> {
    //if (this.brandId && this.brandId.length > 0) {
      const getAllIndications = await sp.web.lists.getByTitle(ListTitles.brandTrackerIndications).items
        .select('Title,Id,TA/Title,TA/Id,Brand/Id,Brand/Title,IndicationLogoUrl,Brand/Title,IndicaitonDescriptionText')
        .expand('TA,Brand')
        .filter(`Brand/Title eq '${this.brandName}'`)
        .getAll();
      return getAllIndications;
   //}
  }

  async getRegions(): Promise<any> {
   //if (this.brandId && this.brandId.length > 0) {
      const getAllRegions = await sp.web.lists.getByTitle(ListTitles.brandTrackerRegions).items
        .select('Title,Id,Brand/Id,Brand/Title')
        .expand('Brand')
        .filter(`Brand/Title eq '${this.brandName}'`)
        .getAll();
      return getAllRegions;
  //  }
  }

  async getCountries(): Promise<any> {
  //  if (this.brandId && this.brandId.length > 0) {
      const getAllCountries = await sp.web.lists.getByTitle(ListTitles.brandTrackerCountries).items
        .select('Title,Id,Region/Title,Region/Id,Brand/Id,Brand/Title')
        .expand('Region,Brand')
        .filter(`Brand/Title eq '${this.brandName}'`)
        .getAll();
      return getAllCountries;
    //}
  }

  async getCountriesForCurrentUser(userId: number): Promise<any> {
  //  if (this.brandId && this.brandId.length > 0) {
      const getRoleId = await sp.web.lists.getByTitle(ListTitles.brandTrackerUserPermissions).items
        .select('Users/Id,AreaRole/Id,AffiliateRole/Id,AreaRole/Title,AffiliateRole/Title,Brand/Id,Brand/Title')
        .expand('Users,AreaRole,AffiliateRole,Brand')
        .filter(`Users/Id eq ${userId} and Brand/Title eq '${this.brandName}'`)
        .getAll();
      return getRoleId;
  //  }
  }

  async getLimitedRegions(areaRoles: any): Promise<any> {
    //  if (this.brandId && this.brandId.length > 0) {	
    let query = '';
    query += areaRoles.map(x => `Area/Id eq ${x.Id}`).join(' or ');
    const getLimitedRegions = await sp.web.lists.getByTitle(ListTitles.brandTrackerRegions).items
      .select('Title,Id,Area/Id,Area/Title,Brand/Id,Brand/Title')
      .expand('Area,Brand')
      .filter(`${query} and Brand/Title eq '${this.brandName}'`)
      .getAll();
    return getLimitedRegions;
    //  }	
  }

  async getLimitedCountries(affiliateRoles: any): Promise<any> {
    //  if (this.brandId && this.brandId.length > 0) {	
    let query = '';
    query += affiliateRoles.map(x => `Id eq ${x.Id}`).join(' or ');
    const getLimitedCountries = await sp.web.lists.getByTitle(ListTitles.brandTrackerCountries).items
      .select('Title,Id,Region/Id,Region/Title,Brand/Id,Brand/Title')
      .expand('Region,Brand')
      .filter(`${query} and Brand/Title eq '${this.brandName}'`)
      .getAll();
    return getLimitedCountries;
    //  }	
  }

  //for list view form
  async getBrandTrackerDataList(): Promise<any> {
   // if (this.brandId && this.brandId.length > 0) {
      const brandTrackerDataList = await sp.web.lists.getByTitle(ListTitles.brandTrackerData).items
        .expand('Region,Country,Disease_x0020_area,Indication,Brand')
        .select('*, Brand/Id,Brand/Title,Region/Title,Country/Title,Disease_x0020_area/Title,Indication/Title,Disease_x0020_area/Id,Indication/Id')
        .filter(`Brand/Title eq '${this.brandName}'`)
        .getAll();
      return brandTrackerDataList;
  //  }
  }

  //view form on click of item
  async getBrandTrackerDataId(id): Promise<any> {
    const getItemByID = await sp.web.lists.getByTitle(ListTitles.brandTrackerData).items
      .getById(id)
      .expand('Region,Country,Disease_x0020_area,Indication')
      .select('*, Region/Title,Country/Title,Disease_x0020_area/Title,Indication/Title,Disease_x0020_area/Id,Indication/Id')
      .get();
    return getItemByID;
  }

  async getSimilarRecord(brandTrackerDatas: brandTrackerData): Promise<any> {
    const filter = `Disease_x0020_area/ID eq '${brandTrackerDatas.Disease_x0020_areaId}'
                    and Indication/ID eq '${brandTrackerDatas.IndicationId}'
                    and Region/ID eq '${brandTrackerDatas.RegionId}'
                    and Country/ID eq '${brandTrackerDatas.CountryId}'
                    `;
    return await sp.web.lists.getByTitle(ListTitles.brandTrackerData).items
      .filter(filter).getAll();
  }

  async getSimilarRecordWithID(dataID: number, brandTrackerDatas: brandTrackerData): Promise<any> {
    const filter = `Disease_x0020_area/ID eq '${brandTrackerDatas.Disease_x0020_areaId}'
                    and Indication/ID eq '${brandTrackerDatas.IndicationId}'
                    and Region/ID eq '${brandTrackerDatas.RegionId}'
                    and Country/ID eq '${brandTrackerDatas.CountryId}'
                    and ID ne '${dataID}'`;
    return await sp.web.lists.getByTitle(ListTitles.brandTrackerData).items
      .filter(filter).getAll();
  }

  async createBrandTrackerData(brandTrackerDataProperties: brandTrackerData): Promise<IItemAddResult> {
    console.log('to get data', brandTrackerDataProperties);
    try {
      //return sp.web.lists.getByTitle(ListTitles.brandTrackerData).items.add(brandTrackerDataProperties);
      return sp.web.lists.getByTitle(ListTitles.brandTrackerData).items.add({
        Disease_x0020_areaId: brandTrackerDataProperties.Disease_x0020_areaId,
        IndicationId: brandTrackerDataProperties.IndicationId,
        RegionId: brandTrackerDataProperties.RegionId,
        CountryId: brandTrackerDataProperties.CountryId,
        Label: brandTrackerDataProperties.Label,
        MarketingStatus: brandTrackerDataProperties.MarketingStatus,
        HTAStatus: brandTrackerDataProperties.HTAStatus,
        ReimbursementStatus: brandTrackerDataProperties.ReimbursementStatus,
        PercentageofReimbursement: brandTrackerDataProperties.PercentageofReimbursement,
        ConditionsofReimbursement: brandTrackerDataProperties.ConditionsofReimbursement,
        SpecificConditionsLimitations: brandTrackerDataProperties.SpecificConditionsLimitations,
        ReimbursementSetting: brandTrackerDataProperties.ReimbursementSetting,
        DifferencesOnReimbursement: brandTrackerDataProperties.DifferencesOnReimbursement,
        RouteOfReimbursement:
          { results: brandTrackerDataProperties.RouteOfReimbursement },
        AdditionalRegionalRestrictions: brandTrackerDataProperties.AdditionalRegionalRestrictions,
        HTAResubmission: brandTrackerDataProperties.HTAResubmission,
        FormularyList: brandTrackerDataProperties.FormularyList,
        Contracting_x0026_Tendering: brandTrackerDataProperties.Contracting_x0026_Tendering,
        DRG: brandTrackerDataProperties.DRG,
        CommentsOnMarketingStatus: brandTrackerDataProperties.CommentsOnMarketingStatus,	
        CommentsOnHTAStatus: brandTrackerDataProperties.CommentsOnHTAStatus,	
        ScopeOfReimbursement: brandTrackerDataProperties.ScopeOfReimbursement,        
        CommentsOnRouteOfReimbursement: brandTrackerDataProperties.CommentsOnRouteOfReimbursement,        
        BrandId: this.brandId && this.brandId.length > 0 ? this.brandId[0].Id : null
      });
    }
    catch (error) {
      console.log('Failed to save data', error);
      return error.data;
    }
  }

  async updateBrandTrackerData(itemId: number, brandTrackerDataProperties: brandTrackerData): Promise<IItemUpdateResult> {
    try {
      return sp.web.lists.getByTitle(ListTitles.brandTrackerData).items.getById(itemId).update({
        Disease_x0020_areaId: brandTrackerDataProperties.Disease_x0020_areaId,
        IndicationId: brandTrackerDataProperties.IndicationId,
        RegionId: brandTrackerDataProperties.RegionId,
        CountryId: brandTrackerDataProperties.CountryId,
        Label: brandTrackerDataProperties.Label,
        MarketingStatus: brandTrackerDataProperties.MarketingStatus,
        HTAStatus: brandTrackerDataProperties.HTAStatus,
        ReimbursementStatus: brandTrackerDataProperties.ReimbursementStatus,
        PercentageofReimbursement: brandTrackerDataProperties.PercentageofReimbursement,
        ConditionsofReimbursement: brandTrackerDataProperties.ConditionsofReimbursement,
        SpecificConditionsLimitations: brandTrackerDataProperties.SpecificConditionsLimitations,
        //PricePerPresentation: brandTrackerDataProperties.PricePerPresentation,
        ReimbursementSetting: brandTrackerDataProperties.ReimbursementSetting,
        DifferencesOnReimbursement: brandTrackerDataProperties.DifferencesOnReimbursement,
        //RouteOfReimbursement: brandTrackerDataProperties.RouteOfReimbursement,
        RouteOfReimbursement:
          { results: brandTrackerDataProperties.RouteOfReimbursement },
        AdditionalRegionalRestrictions: brandTrackerDataProperties.AdditionalRegionalRestrictions,
        HTAResubmission: brandTrackerDataProperties.HTAResubmission,
        FormularyList: brandTrackerDataProperties.FormularyList,
        Contracting_x0026_Tendering: brandTrackerDataProperties.Contracting_x0026_Tendering,
        DRG: brandTrackerDataProperties.DRG,
        CommentsOnMarketingStatus: brandTrackerDataProperties.CommentsOnMarketingStatus,	
        CommentsOnHTAStatus: brandTrackerDataProperties.CommentsOnHTAStatus,	
        ScopeOfReimbursement: brandTrackerDataProperties.ScopeOfReimbursement,        
        CommentsOnRouteOfReimbursement: brandTrackerDataProperties.CommentsOnRouteOfReimbursement,        
        BrandId: this.brandId && this.brandId.length > 0 ? this.brandId[0].Id : null
      });
    }
    catch (error) {
      console.log('Failed to update data', error);
      return error.data;
    }
  }

  async deleteRequest(id: number): Promise<void> {
    await execute(() => sp.web.lists.getByTitle(ListTitles.brandTrackerData).items
      .getById(id).recycle());
  }
}